import React, { useEffect, useState } from 'react'
import PlayCircleRoundedIcon from '@mui/icons-material/PlayCircleRounded'
import StopCircleRoundedIcon from '@mui/icons-material/StopCircleRounded'
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded'
import RemoveCircleRoundedIcon from '@mui/icons-material/RemoveCircleRounded'
import ModeCommentRoundedIcon from '@mui/icons-material/ModeCommentRounded'
import WbIncandescentIcon from '@mui/icons-material/WbIncandescent'
const Subtitles = (props) => {
  const {
    text,
    lineNumber,
    //showCC,
    botType,
    ttsPlayType,
    isSeqPlaying,
    onFrwdSkipClick,
    onStopClick,
    isReplayHappening,
    isTutor,
    onHideSubtitle,
    knovoHelpClick,
    displayWlakthrough,
    tutorTalking,
    readmoreUrl,
    onReadmoreClick,
    isHintDisplay,
    onHintIconClicked,
    isAiChatBotVisible,
    completedAllCompData,
    muteStatus,
    isSmartPaper,
    newlyOpenedActivity,
    isCanvas
  } = props
  const [isBotMute, setIsBotMute] = useState(false)
  const [isMuteClick, setIsMuteClick] = useState(false)
  const [isHideSubtitle, setIsHideSubtitle] = useState(false)
  const [showCC, setShowCC] = useState(false)
  const [readmoreClick, setReadmoreClick] = useState(false)

  useEffect(() => {
    if (isMuteClick) {
      setIsMuteClick(false)
    }
  }, [isMuteClick])

  useEffect(() => {
    if (onHideSubtitle) {
      onHideSubtitle(isHideSubtitle)
    }
  }, [isHideSubtitle])

  useEffect(() => {
    if (knovoHelpClick) {
      setIsHideSubtitle(true)
    }
  }, [knovoHelpClick])

  useEffect(() => {
    if (readmoreClick) {
      onReadmoreClick(readmoreClick)
      setTimeout(() => {
        setReadmoreClick(false)
      }, 2000)
    }
  }, [readmoreClick])

  useEffect(() => {
    if (Array.isArray(text)) {
      if (text[0] === '') {
        setShowCC(false)
      } else {
        setShowCC(true)
      }
    } else {
      if (text === '') {
        setShowCC(false)
      } else {
        setShowCC(true)
      }
    }
  }, [text])

  function renderProceedMessage() {
    return (
      <div
        className='subtitleContainer'
        style={{ right: tutorTalking ? '150px' : '100px' }}
      >
        <div
          className='subtitleLabelContainer'
          style={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '300px',
            overflow: 'hidden',
            justifyContent: 'flex-end'
          }}
        >
          <p className='subtitleLabel subtitleLabelSelected'>
            Click here to proceed
          </p>
        </div>
        <div className='subtitleButtonContainer'>
          <div
            className='bot-handle-icon-div'
            onClick={() => {
              onFrwdSkipClick()
            }}
          >
            <div className='arrow-skip-circle'>
              <ArrowForwardIosRoundedIcon
                style={{
                  width: '20px',
                  height: '20px',
                  color: '#ffffff'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  function renderInitialBot() {
    if (isTutor && text.length !== 0) {
      return (
        <div
          className='subtitleContainer'
          style={{ right: tutorTalking ? '150px' : '100px' }}
        >
          <div
            className='subtitleLabelContainer'
            style={{
              display: isTutor
                ? completedAllCompData && completedAllCompData.length > 0
                  ? 'flex'
                  : 'none'
                : 'flex',
              flexDirection: 'column',
              maxHeight: '300px',
              overflow: 'hidden',
              justifyContent: 'flex-end'
            }}
          >
            {completedAllCompData && completedAllCompData.length > 0 ? (
              tutorTalking ? (
                <div>
                  {completedAllCompData.map((textLabel, textIndex) => {
                    if (textIndex < completedAllCompData.length - 1) {
                      return (
                        <p
                          key={textIndex.toString()}
                          className='subtitleLabel'
                          // style={{ color: '#3EC986' }}
                        >
                          {textLabel}
                        </p>
                      )
                    }
                  })}

                  <p className='subtitleLabel subtitleLabelSelected'>
                    {text[lineNumber]}
                  </p>
                </div>
              ) : (
                completedAllCompData.map((textLabel, textIndex) => {
                  return (
                    <p
                      key={textIndex.toString()}
                      className='subtitleLabel'
                      // style={{ color: '#3EC986' }}
                    >
                      {textLabel}
                    </p>
                  )
                })
              )
            ) : null}
            {/* {text && text.length > 0
              ? text.map((textLabel, textIndex) => {
                  return (
                    <p
                      key={text[lineNumber] + textIndex.toString()}
                      className={
                        text[lineNumber] === textLabel
                          ? 'subtitleLabel subtitleLabelSelected'
                          : 'subtitleLabel'
                      }
                      style={{
                        display: lineNumber < textIndex ? 'flex' : 'none'
                      }}
                    >
                      {textLabel}
                    </p>
                  )
                })
              : undefined} */}
          </div>
          <div className='subtitleButtonContainer'>
            <div
              className='bot-handle-icon-div'
              onClick={() => {
                onFrwdSkipClick()
              }}
            >
              <div className='arrow-skip-circle'>
                <ArrowForwardIosRoundedIcon
                  style={{
                    width: '20px',
                    height: '20px',
                    color: '#ffffff'
                  }}
                />
              </div>
            </div>

            <div
              className='bot-handle-icon-div'
              onClick={() => {
                setIsHideSubtitle(true)
              }}
            >
              <RemoveCircleRoundedIcon
                style={{
                  width: '35px',
                  height: '35px',
                  color: '#ffc42d'
                }}
              />
            </div>
          </div>
        </div>
      )
    } else {
      return null
    }
  }

  function renderHintSubtitle() {
    if (text !== '') {
      return (
        <div
          className='subtitleLabelContainer'
          style={{
            display: isTutor
              ? showCC
                ? 'flex'
                : 'none'
              : text === '' || text.length === 0
              ? 'none'
              : 'flex',
            flexDirection: 'column',
            maxHeight: '300px',
            overflow: 'hidden',
            justifyContent: 'flex-end'
          }}
        >
          <p className={'subtitleLabel subtitleLabelSelected'}>{text}</p>
          {isSmartPaper && readmoreUrl !== '' && (
            <div
              className='hint-read-more-cont'
              onClick={() => {
                setReadmoreClick(true)
              }}
            >
              <p className='hint-read-more-label'>Additional help</p>
            </div>
          )}
        </div>
      )
    } else {
      return null
    }
  }

  useEffect(() => {
    if (ttsPlayType === 'sequence') {
      var objDiv = document.getElementById('subtSeqDiv')
      if (objDiv) {
        objDiv.scrollTop = objDiv.scrollHeight
      }
    }
  }, [completedAllCompData])

  function renderSequenceSubtitle() {
    return (
      <div
        id='subtSeqDiv'
        className='subtitleLabelContainer'
        style={{
          display: isTutor
            ? completedAllCompData && completedAllCompData.length > 0
              ? 'flex'
              : 'none'
            : 'flex',
          flexDirection: 'column',
          maxHeight: '300px',
          overflow: 'auto'
        }}
      >
        {completedAllCompData && completedAllCompData.length > 0 ? (
          isSeqPlaying ? (
            <div>
              {completedAllCompData.map((textLabel, textIndex) => {
                if (textIndex < completedAllCompData.length - 1) {
                  return (
                    <p
                      key={textIndex.toString()}
                      className='subtitleLabel'
                      // style={{ color: '#3EC986' }}
                    >
                      {textLabel}
                    </p>
                  )
                }
              })}

              <p className='subtitleLabel subtitleLabelSelected'>
                {text[lineNumber]}
              </p>
            </div>
          ) : (
            completedAllCompData.map((textLabel, textIndex) => {
              return (
                <p
                  key={textIndex.toString()}
                  className='subtitleLabel'
                  // style={{ color: '#3EC986' }}
                >
                  {textLabel}
                </p>
              )
            })
          )
        ) : null}
      </div>
    )
  }

  function renderFeedbackSubtitle() {
    if (text.length > 0) {
      return (
        <div
          className='subtitleLabelContainer'
          style={{
            display: isTutor
              ? showCC
                ? 'flex'
                : 'none'
              : text === '' || text.length === 0
              ? 'none'
              : 'flex',
            flexDirection: 'column',
            maxHeight: '300px',
            overflow: 'hidden',
            justifyContent: 'flex-end'
          }}
        >
          {text && text.length > 0
            ? text.map((textLabel, textIndex) => {
                return (
                  <p
                    key={text[lineNumber] + textIndex.toString()}
                    className={
                      text[lineNumber] === textLabel
                        ? 'subtitleLabel subtitleLabelSelected'
                        : 'subtitleLabel'
                    }
                  >
                    {textLabel}
                  </p>
                )
              })
            : undefined}
        </div>
      )
    } else {
      return null
    }
  }

  function renderButtons() {
    return (
      <div
        className='subtitleButtonContainer'
        style={{
          display:
            botType === 'sequence'
              ? isTutor
                ? completedAllCompData && completedAllCompData.length > 0
                  ? 'flex'
                  : 'none'
                : 'flex'
              : 'flex'
        }}
      >
        {/* Hint icon to display the component hint if available */}
        {isHintDisplay && (
          <div
            className='bot-handle-icon-div pulse'
            onClick={() => {
              onHintIconClicked()
            }}
          >
            <WbIncandescentIcon
              style={{
                width: '30px',
                height: '30px',
                color: '#ffc42d',
                cursor: 'pointer',
                rotate: '180deg'
              }}
            />
          </div>
        )}
        {/* Mute icon but it will stop the tts while playing */}
        {/* {isSeqPlaying && ttsPlayType !== 'hint' && (
          <div
            className='bot-handle-icon-div'
            onClick={() => {
              setReadmoreClick(false)
              onStopClick()
            }}
          >
            <VolumeOffRoundedIcon
              style={{
                width: '30px',
                height: '30px',
                color: '#6644ff',
                cursor: 'pointer'
              }}
            />
          </div>
        )} */}
        {/* <div
          className='bot-handle-icon-div'
          onClick={() => {
            setReadmoreClick(false)
            setIsMuteClick(true)
          }}
        >
          {muteStatus ? (
            <VolumeOffRoundedIcon
              style={{
                width: '25px',
                height: '25px',
                color: '#6644ff',
                cursor: 'pointer'
              }}
            />
          ) : (
            <VolumeUpRoundedIcon
              style={{
                width: '25px',
                height: '25px',
                color: '#6644ff',
                cursor: 'pointer'
              }}
            />
          )}
        </div> */}
        {/* Stop and play the components sequence message */}
        {botType === 'sequence' && (
          <div
            className='bot-handle-icon-div'
            onClick={() => {
              setReadmoreClick(false)
              onStopClick()
            }}
          >
            <span>
              {isSeqPlaying ? (
                <StopCircleRoundedIcon
                  style={{
                    width: '35px',
                    height: '35px',
                    color: '#6644ff',
                    cursor: 'pointer'
                  }}
                />
              ) : (
                <PlayCircleRoundedIcon
                  style={{
                    width: '35px',
                    height: '35px',
                    color: '#6644ff',
                    cursor: 'pointer'
                  }}
                />
              )}
            </span>
          </div>
        )}

        {/* Skip the component and move to next */}
        {ttsPlayType !== 'hint' && (
          <div
            className='bot-handle-icon-div'
            onClick={() => {
              onFrwdSkipClick()
            }}
          >
            <div className='arrow-skip-circle'>
              <ArrowForwardIosRoundedIcon
                style={{
                  width: '20px',
                  height: '20px',
                  color: '#ffffff'
                }}
              />
            </div>
          </div>
        )}
        {/* Minimize or maximize the subtile container */}
        <div
          className='bot-handle-icon-div'
          onClick={() => {
            setIsHideSubtitle(true)
          }}
        >
          <RemoveCircleRoundedIcon
            style={{
              width: '35px',
              height: '35px',
              color: '#ffc42d'
            }}
          />
        </div>
      </div>
    )
  }

  function renderOtherSubtitles() {
    return (
      <div
        className='subtitleContainer'
        style={{
          right: isCanvas
            ? tutorTalking
              ? '50px'
              : '0px'
            : tutorTalking
            ? '150px'
            : '100px'
        }}
      >
        {ttsPlayType === 'hint'
          ? renderHintSubtitle()
          : ttsPlayType === 'sequence'
          ? renderSequenceSubtitle()
          : renderFeedbackSubtitle()}
        {ttsPlayType !== 'feedback' && renderButtons()}
      </div>
    )
  }

  if (displayWlakthrough || isAiChatBotVisible) {
    return null
  } else {
    if (isHideSubtitle || isReplayHappening) {
      return (
        <div
          className='hideSubtitleContainer'
          style={{
            right: tutorTalking ? '80px' : '50px',
            top: tutorTalking ? '-50px' : '15%'
          }}
          onClick={() => {
            if (!isReplayHappening) {
              setIsHideSubtitle(false)
            }
          }}
        >
          <ModeCommentRoundedIcon
            style={{ width: '25px', height: '25px', color: '#ffffff' }}
          />
        </div>
      )
    } else {
      return (
        <span>
          {newlyOpenedActivity
            ? renderProceedMessage()
            : botType === 'tutor'
            ? renderInitialBot()
            : renderOtherSubtitles()}
        </span>
      )
    }
  }
}
export { Subtitles }
